import {createAction, props} from '@ngrx/store';

export const trackedOewa = createAction(
  '[Page View] Pushed OEWA Path to be tracked.',
  props<{ payload: { oewaPath: string } }>()
);
